"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementRange = void 0;

/**
 * @description
 * convert selectionRange from an object into array
 * @Function
 *
 * @example
 * //converts
 * //from
 * {
 *   selectionStart: 0,
 *   selectionEnd: 5
 * }
 * //into
 * [0, 5]
 * @name skybase-components.sb-ipv4-input.utils#getElementRange
 * @param  {Number} selectionStar
 * @param  {Number} selectionEnd
 * @return {skybase-components.sb-ipv4-input.utils#Range}
 */
var getElementRange = function getElementRange(_ref) {
  var selectionStart = _ref.selectionStart,
      selectionEnd = _ref.selectionEnd;
  return [selectionStart, selectionEnd];
};

exports.getElementRange = getElementRange;
//# sourceMappingURL=get-element-range.js.map